// extracted by mini-css-extract-plugin
export default {"root":"ReadMore_root__1s751","footer":"ReadMore_footer__ecFCX","fade":"ReadMore_fade__PzBAc","fade_open":"ReadMore_fade_open__1tKNA","reademore":"ReadMore_reademore__En0zX"};